import { makeServerRequest } from './util';

const apiPrefix = "/api/v1/customers";


export const fetchBranchGeoLocationSuccess = (payload) => {
    return {
        type: "FETCH_BRANCH_GEO_LOCATION_SUCCESS",
        payload: payload
    };
};

export const fetchBranchGeoLocationFailure = (error) => {
    return {
        type: "FETCH_BRANCH_GEO_LOCATION_FAILURE",
        payload: error
    };
};

export const fetchBranchGeoLocation = (customerId, branchId) => {
    return (dispatch) => {
        dispatch({type: "FETCH_BRANCH_GEO_LOCATION"});
        return makeServerRequest(apiPrefix + "/" + customerId + "/branches/" + branchId + "/map").then(
            response => dispatch(fetchBranchGeoLocationSuccess(response.data))
        ).catch(
            error => dispatch(fetchBranchGeoLocationFailure(error))
        );
    };
};







// WEBPACK FOOTER //
// ./src/store/actions/branchMap.js